import React, { useState, useEffect, useMemo, useRef } from 'react';
import Select from "react-select";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import { timeToYearmonthDay, timeToDateFill } from "../../herramientas/DateFormat";
import { TablePageable } from "../../Helpers";
import MapaEvidencia from './MapaEvidencia';
import DetalleAlarma from './DetalleAlarma';
import VideoPlayer from './VideoPlayer';
import InstrumentosVelocidad from './InstrumentosVelocidad';

let estatusTemp= {};
let estatusIndex= 0;
let duration= 0;

const AlertasCctvComponente = ({url, disp, token }) => {
  const [ videoRef ] = useState([
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ]);
  const [ reporte, setReporte ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [ mensaje, setMensaje ] = useState("");
  const [requestBody, setRequestBody]= useState({
    "key": token,
    "dispositivos": [disp],
    "tipos": [],
    "starttime": timeToYearmonthDay(new Date().getTime()),
    "endtime": timeToYearmonthDay(new Date().getTime())
  });
  const [tipos, setTipos] = useState([]);
  const [tiposList, setTiposList ] = useState([]);
  const [dispositivo, setDispositivo ] = useState({});
  const [alarma, setAlarma]= useState({});
  const [videos, setVideos]= useState({});
  const [alarmaEstatus, setAlarmaEstatus]= useState([]);
  const [currentAlarmaEstatus, setCurrentAlarmaEstatus]= useState({});
  const [playing, setPlaying]= useState(false);
  const [volume, setVolume]= useState(1);
  const [muted, setMuted]= useState(false);

  // Auto-refresh
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [refreshInterval, setRefreshInterval] = useState(10);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [showAutoMsg, setShowAutoMsg] = useState(true);
  const intervalRef = useRef(null);
  const refrescarRef = useRef(null);

  useEffect(() => {
    Crud_Catalogos("alarmas_tipos/dhl?key="+token, "get", "", "").then((resp) => {
      if(resp){
        let tiposTemp= [];
        for( let tipo of resp ){
          tiposTemp.push({ value: tipo.idAlarmaTipo, label: tipo.spanish, data: tipo});
        }
        setTipos(tiposTemp);
      }
    }).catch(err =>{ console.log(err); });

    Crud_Catalogos("dispositivos/porid?id="+disp+"&key="+token, "get", "", "").then((resp) => {
      if(resp.data){
        setDispositivo(resp.data);
      }
    }).catch(err =>{ console.log(err); });
  },[]);

  useEffect(() => {
    if(tipos.length){
      refrescar();
    }
  },[tipos]);

  // Auto-refresh
  useEffect(() => {
    if (autoRefresh) {
      intervalRef.current = setInterval(() => {
        refrescarRef.current(true);
        setLastUpdate(new Date());
      }, refreshInterval * 1000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [autoRefresh, refreshInterval]);

  useEffect(() => {
    if(autoRefresh){
      setShowAutoMsg(true);
      const timer = setTimeout(() => setShowAutoMsg(false), 20000);
      return () => clearTimeout(timer);
    }
  }, [autoRefresh]);

  useEffect(() => {
    if(alarma.id){
      Crud_Catalogos("evidencias/video/detail?unidad="+disp+"&eid="+alarma.eid+"&key="+token, "get", "", "").then((resp) => {
        const res= resp;
        if(resp.data && resp.data.codigo === 200 && resp.data.data.code === 200){
          setVideos(resp.data.data.data);
        }
        if(res && res.codigo === 200 && res.data.codigo === 200){
          const archivos= res.data.data.data;
          for( let alarmFiles of archivos){
            if( alarmFiles.downloadStatus && alarmFiles.downloadStatus === "COMPLETED" ){
              setVideos(alarmFiles.files);
            }else{
              alert(alarmFiles.downloadStatus);
            }
          }
        }
      }).catch(err =>{ console.log(err); });

      Crud_Catalogos("evidencias/alarma_estatus?unidad="+disp+"&eid="+alarma.eid+"&key="+token, "get", "", "").then((resp) => {
        if(resp.data && resp.data.codigo === 200 && resp.data.data.code === 200){
          setAlarmaEstatus(resp.data.data.data);
        }
      }).catch(err =>{ console.log(err); });
    }
  },[alarma]);

  const refrescar =(isAuto = false)=>{
    if(!isAuto){
      setMensaje("");
      const start = new Date(requestBody.starttime);
      const end = new Date(requestBody.endtime);
      if(isNaN(start.getTime()) || isNaN(end.getTime())){
        setMensaje("Las fechas ingresadas no son válidas");
        return;
      }
      if(start > end){
        setMensaje("La fecha de inicio no puede ser mayor a la fecha fin");
        return;
      }
      const sixMonthsMs = 6 * 30 * 24 * 60 * 60 * 1000;
      if((end.getTime() - start.getTime()) > sixMonthsMs){
        setMensaje("El rango máximo permitido es de 6 meses");
        return;
      }
      setReporte([]);
      reset();
    }
    setLoading(true);

    let requestBodyTemp= {...requestBody};
    if(isAuto){
      const today = timeToYearmonthDay(new Date().getTime());
      requestBodyTemp.starttime= today+" 00:00:00";
      requestBodyTemp.endtime= today+" 23:59:59";
    }else{
      requestBodyTemp.starttime= requestBodyTemp.starttime+" 00:00:00";
      requestBodyTemp.endtime= requestBodyTemp.endtime+" 23:59:59";
    }

    let tiposListTemp=[];
    if(!tiposList.length){
      for( let tipo of tipos ){
        tiposListTemp.push(tipo.value);
      }
    }else{
      for( let tipo of tiposList ){
        tiposListTemp.push(tipo.value);
      }
    }
    requestBodyTemp.tipos= tiposList.length? requestBodyTemp.tipos: tiposListTemp;

    Crud_Catalogos("evidencias/video/5", "post", requestBodyTemp, "").then((res) => {
      if(res.status === 200){
        for( let r of res.data ){
          r.servidorFecha= timeToDateFill(r.servidorFecha);
          r.alarmaFecha= timeToDateFill(r.alarmaFecha);
        }
        setReporte(res.data);
        setLastUpdate(new Date());
      }
    }).catch(err =>{ console.log(err); }).finally(()=>{ setLoading(false); });
  }
  refrescarRef.current = refrescar;

  const seguirVideo=()=>{
    setTimeout(() => {
      if (videoRef[0] && videoRef[0].current) {
        estatusIndex= videoRef[0].current.currentTime | 0;
        const estatus= alarmaEstatus[estatusIndex] ? alarmaEstatus[estatusIndex] : {};
        if(!estatusTemp.time || estatusTemp.time !== estatus.time){
          estatusTemp= estatus;
          setCurrentAlarmaEstatus(estatus);
        }
        if( !videoRef[0].current.paused ){
          seguirVideo();
        }else{
          setPlaying(false);
        }
      }
    }, 400);
  }

  const getGraficaVelocidad =()=>{
    let labels= [];
    let data= [];
    for( let i= 0; i<estatusIndex; i++ ){
      if( alarmaEstatus[i]){
        labels.push(alarmaEstatus[i].time);
        data.push(alarmaEstatus[i].sateliteSpeed);
      }else{
        let videoTemp= videos.eid? videos: {};
        if(videoTemp.eid){
          let fecha= new Date(new Date(videoTemp.startTime).getTime()+(1000*estatusIndex));
          labels.push(timeToDateFill(fecha));
          data.push(0);
        }
      }
    }
    return {
      fill: true,
      labels: labels,
      datasets: [{
        label: "Velocidad",
        data: data,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      }]
    }
  }

  const reset=()=>{
    setAlarma({});
    setVideos({});
    setAlarmaEstatus([]);
    setCurrentAlarmaEstatus({});
    setPlaying(false);
    setVolume(1);
    setMuted(false);
    estatusTemp= {};
    estatusIndex= 0;
  }

  // Memoized components
  const memoizedDetalleAlarma = useMemo(() => (
    <DetalleAlarma alarma={alarma} dispositivo={dispositivo} videos={videos} />
  ), [alarma, dispositivo, videos]);

  const memoizedVideoPlayer = useMemo(() => (
    <VideoPlayer 
      videos={videos}
      dispositivo={dispositivo}
      alarma={alarma}
      videoRef={videoRef}
      playing={playing}
      setPlaying={setPlaying}
      volume={volume}
      setVolume={setVolume}
      muted={muted}
      setMuted={setMuted}
      estatusIndex={estatusIndex}
      seguirVideo={seguirVideo}
      token={token}
    />
  ), [videos, dispositivo, alarma, videoRef, playing, volume, muted, estatusIndex]);

  const memoizedInstrumentosVelocidad = useMemo(() => (
    <InstrumentosVelocidad 
      alarma={alarma} 
      currentAlarmaEstatus={currentAlarmaEstatus} 
      getGraficaVelocidad={getGraficaVelocidad} 
    />
  ), [alarma, currentAlarmaEstatus]);

  const memoizedMapaEvidencia = useMemo(() => (
    <MapaEvidencia alarmas={reporte.filter(a=> a.idDispositivo === dispositivo.id && a.id === alarma.id)} alarma={alarma}/>
  ), [reporte, dispositivo.id, alarma.id]);

  return (
    <div className='container-fluid p-1'>
      <h5 hidden={alarma.id}> Unidad: {dispositivo? dispositivo.nombre:""} </h5>
      <hr color='white'/>
      <div className='row mt-5'>
        <div className='col-12' hidden={alarma.id}>
          {mensaje && <div className="alert alert-warning" role="alert">{mensaje}</div>}
          {autoRefresh && showAutoMsg && <div className="alert alert-info" role="alert">Auto-refresh activo: desactívelo para realizar búsquedas por fechas.</div>}
          <TablePageable
            titulo={
              <div>
                <div className="row mb-1">
                  {!autoRefresh && (
                    <>
                      <div className='col'>
                        <label>Fecha inicio</label>
                        <input className="form-control" type="date"
                          value={requestBody.starttime}
                          onChange={(e)=>{ setRequestBody({...requestBody, starttime: e.target.value}); }}
                          min="2024-05-01" max={timeToYearmonthDay(new Date().getTime())} />
                      </div>
                      <div className='col'>
                        <label>Fecha fin</label>
                        <input className="form-control" type="date"
                          value={requestBody.endtime}
                          onChange={(e)=>{ setRequestBody({...requestBody, endtime: e.target.value}); }}
                          min="2024-05-01" max={timeToYearmonthDay(new Date().getTime())} />
                      </div>
                    </>
                  )}
                  <div className='col'>
                    <label>Tipo</label>
                    <Select
                      placeholder="Todos"
                      value={tiposList}
                      onChange={ (e)=>{
                        setTiposList(e || []);
                        let tiposTemp= [];
                        if(e && e.length){
                          for(let t of e){
                            tiposTemp.push(t.value);
                          }
                        }
                        setRequestBody({...requestBody, tipos: tiposTemp});
                      }}
                      options={tipos}
                      isMulti={true}
                    />
                  </div>
                  <div className='col'>
                    <div className="d-flex align-items-center">
                      {!loading && <i className="fa fa-refresh text-primary btn"
                        style={{ fontSize: "40px"}}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={"Actualizar"}
                        onClick={()=>{ refrescar(); }}></i>}
                      {loading && <i className="fa fa-spinner fa-spin text-primary" style={{ fontSize: "40px", marginTop: "5px" }}></i>}
                      <div className="ml-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={autoRefresh}
                            onChange={(e) => setAutoRefresh(e.target.checked)}
                          />
                          <label className="form-check-label">Auto-refresh</label>
                        </div>
                        {autoRefresh && (
                          <div className="d-flex align-items-center mt-1">
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              style={{width: '60px'}}
                              value={refreshInterval}
                              onChange={(e) => setRefreshInterval(Number(e.target.value))}
                              min="5"
                            />
                            <span className="ml-1" style={{fontSize:"12px"}}>seg</span>
                          </div>
                        )}
                      </div>
                    </div>
                    {autoRefresh && lastUpdate && (
                      <small className="text-muted">Últ: {lastUpdate.toLocaleTimeString()}</small>
                    )}
                  </div>
                </div>
              </div>
            }
            lista= { reporte }
            columnas={
              [
                { columna: "detalle", label: "Detalle",
                  form: (e)=> <i className="fa fa-list-alt" style={{height: '100%', color: e.existeVideo ? 'green' : undefined}}></i>,
                  enClick: (e)=> { setAlarma(e); }
                },
                { columna: "servidorFecha", label: "Fecha" },
                { columna: "coordenadas", label: "Coordenadas",
                  form: (e)=> `${e.latitud}, ${e.longitud}`,
                  valor: (e)=> `${e.latitud}, ${e.longitud}`
                },
                { columna: "velocidad", label: "Velocidad",
                  form: (e)=> `${e.velocidad} km/h`,
                  valor: (e)=> `${e.velocidad} km/h`,
                },
                { columna: "tipoString", label: "Tipo"},
                { columna: "driverName", label: "Operador"},
                { columna: "id", label: "ID"},
              ]
            }
            id= "id"
            selected={(e)=>{}}
            csvname= {"Reporte de alarmas "}
            paginacion={true}
            elementosPorPagina={15}
          />
        </div>
        { alarma.id?
          <div className='container-fluid'>
            <div className="bg-secondary d-flex justify-content-between align-items-center px-2" style={{ width: '100%', height: '27px'}}>
              <div></div>
              <h5 className="text-white m-0">{alarma.tipoString}</h5>
              <i
                className="fa fa-arrow-circle-left btn text-white"
                style={{
                  fontSize: '25px',
                  transition: 'transform 0.2s ease, color 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                data-toggle="tooltip"
                data-placement="top"
                title={"Regresar"}
                onClick={()=>{reset();}}
              ></i>
            </div>
            <div className='row mt-3'>
              {/* Detalle */}
              <div className='col-2'>
                {memoizedDetalleAlarma}
                <div className='row flex-nowrap'>
                  <div className='col-auto'>
                    <div
                      className="badge"
                      data-toggle="tooltip"
                      data-placement="top"
                      title={"Ver video en vivo (" + (dispositivo ? dispositivo.nombre : "") + ")"}
                    >
                      <i
                        className="fa fa-video-camera"
                        style={{ color: "red", fontSize: "200%" }}
                        onClick={() =>
                          window.open(
                            "https://cctv.skyangel.com.mx/live?token="+token+"&dispositivo=" + dispositivo.id,
                            "sharer",
                            "width=450,height=800,scrollbars=NO"
                          )
                        }
                      ></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* Video */}
              <div className='col-7'>
                {memoizedVideoPlayer}
                {/* Instrumentos */}
                <div className='mt-5'>
                  {memoizedInstrumentosVelocidad}
                </div>
              </div>

              {/* Mapa */}
              <div className='col-3'>
                {memoizedMapaEvidencia}
              </div>
              <hr style={{height: "3px", borderWidth: "0", color: "gray", backgroundColor: "gray"}}></hr>
            </div>
          </div>
        : ""}
      </div>
    </div>
  );
}
export default AlertasCctvComponente;
